import {Flip, toast} from "react-toastify";

export const notify = (text, type) => {
    if (type === "success") {
        toast.success(text, {
            className: "toast-message",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Flip,
        });
    } else if (type === "warning") {
        toast.warn(text, {
            className: "toast-message",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Flip,
        });
    } else {
        toast.error(text,
            {
                className: "toast-message",
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
    }
};